import * as api from '../../api/api-consultar-caso';
import { 
    GET_CONFIG_FORM33,

} from '../types';

export const configuracionFormAction33 = (query) => ({
    type: GET_CONFIG_FORM33,
    payload: api.getConfiguracionForm33(query)
});


